/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Table_RoomsInputs */



/**
* | output |
* | --- |
* | "Table Rooms" |
*
* @param {Og_Cfg_Table_RoomsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_table_rooms = /** @type {((inputs?: Og_Cfg_Table_RoomsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Table_RoomsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Salles")
	if (locale === "es") return /** @type {LocalizedString} */ ("Salas de mesas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Salas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sale Tavoli")
	return /** @type {LocalizedString} */ ("Table Rooms")
});